<div [formGroup]="group" class="price-fs">
    <div class="col-to-row-s-tb" *ngIf="config.title">
        <h2>{{ config.title }}</h2>
    </div>
    <div class="col-to-row-s-tb ctn-top">
        <div class="field-sep flex-1">
            <number [fieldConfig]="{
                        formGroup: group,
                        formControlName: 'value',
                        min: 0,
                        iconDefinition: iconMoney,
                        step: 50,
                        max: 50000,
                        label: wording.priceParADT,
                        fixed: 0
                    }"
                    (onChange)="restrictNumeric('plusOrMinus.percentage', 0)"></number>
        </div>
        <div class="field-sep flex-1" formGroupName="plusOrMinus">
            <number [fieldConfig]="{
                        formGroup: group.get('plusOrMinus'),
                        formControlName: 'percentage',
                        min: 0,
                        iconDefinition: iconPercent,
                        step: 10,
                        max: 100,
                        label: wording.tolerance,
                        fixed: 0
                    }"
                    (onChange)="restrictNumeric('plusOrMinus.percentage', 0, 100)"></number>
        </div>
    </div>
</div>
